<template lang="pug">
v-container(my-4 py-8 fluid)
  v-layout(text-xs-left='', wrap='')
    v-flex(xs10='' offset-xs1)
      h1.title-all 常見問答 Q&A
      br
      v-expansion-panel()
        v-expansion-panel-content.content-all(v-for='(item,i) in faq', :key='i' ripple)
          template(v-slot:header='')
            div Q: {{item.question}}
          v-card
            v-card-text.px-4
              | A: {{item.answer}}


</template>

<script>
export default {
  data: () => ({
    faq: [
      {
        question: "我的學校有參與「投投是道」計畫嗎？",
        answer: `目前有參與的學校共計有68所。核心學校是國立羅東高級中學、新豐高中、臺中市立豐原高中、國立臺南大學附屬高級中學、國立台南一中、臺中家商、鳳山商工、臺中市立文華高級中等學校、國立華僑高級中等學校、國立高雄師範大學附屬高級中學、臺中市立臺中二中、國立暨南國際大學附屬高級中學、新北巿清水高中、國立基隆海事職業學校、臺中市立大甲高中、國立潮州高中、國立新化高工；公投學校則有嘉義市私立嘉華高級中學、南投縣立旭光高中、臺中市青年高級中學、國立台南家齊高中、台中市私立僑泰高級中學、嘉義縣立永慶高中、國立政治大學附屬高級中學、國立臺東大學附屬體育高級中學、中壢家商、南投縣私立三育高級中學、國立華南高商、臺東縣公東高級工業職業學校、屏東縣立東港高中、高雄市立新興高中、嶺東高中、漢英高級中學、新竹高工、國立台東專科學校附設進修學校、苗栗縣育民工家、國立曾文農工、嘉義女中、國立二林高級工商職業學校、臺中市立后綜高級中學、新竹市私立磐石高級中學、上騰學校財團法人花蓮縣上騰高級工商職業學校、新北市私立徐匯高級中學、國立新竹高商、臺中一中、新北市穀保家商、國立玉里高中、國立臺南女子高級中學、國立彰化師範大學附屬高級工業職業學校」、國立竹東高級中學、新北市立秀峰高中、新北市立林口高中、國立嘉義家職、國立北門高級中學臺北市立萬芳高級中學、國立臺南高工、國立頭城家商、台北市立建國高級中學、彰化縣立和美高級中學、高雄市立仁武高中」、嘉義縣私立萬能工商、桃園市立桃園高級中等學校、國立曾文家商、私立開明高職、鳳和高級中學、國立斗六家商、國立旗山農工、國立新營高工`
      },
      {
        question: "如果也想讓我的學校加入怎麼做？",
        answer: "本次活動屬於試辦計畫性質，共有68所學校參與。若學生團體或個別學生有意願，也非常歡迎學生自發在校園也可自辦議題公投，未來也將持續有推動高級中等學校學生會長選舉，以及十八歲投票權之相關計畫，敬請持續關注！"
      },
      {
        question: "我的學校沒有學生會？",
        answer: "依據《高級中等教育法》第53條第1項規定略以：「高級中等學校應輔導學生成立由全校學生選舉產生之學生會」。因此，尚未成立學生會之學校，校方應輔導學生成立之。若您的學校尚未成立學生會，學生可以積極要求校方輔導成立，若學校仍消極不作為，學生可以向教育部國民及學前教育署（簡稱國教署）申訴。"
      },
      {
        question: "我的學校有學生會，但不是由全體學生直接選舉產生？",
        answer: "《高級中等教育法》第53條第1項規定略以：「高級中等學校應輔導學生成立由全校學生選舉產生之學生會」。學生會會長（主席或類似名稱之負責人）應由全校學生選舉產生，其選舉方式，得於組織章程內明定為全校學生直接普遍選舉產生或間接選舉產生，若學生會負責人並非由此二方式選舉產生，學生亦得以向學校積極要求依法改善；若學校仍消極不作為，學生仍可以向教育部國民及學前教育署（簡稱國教署）申訴。"
      }

    ]
  })
};
</script>

<style lang="scss" scoped>
</style>
